import sessionReader from '../store/readHelpers/SessionReader';

export function applyExtraParams(body) {
    const printParams = sessionReader.getPrintParams();
    const layoutParams = sessionReader.getLayoutParams();

    if (
        (printParams !== undefined || layoutParams !== undefined)
        && (sessionReader.isContextPreview()
            || sessionReader.isContextPreviewAssessmentRun()
            || sessionReader.isContextViewDelivery()
            || sessionReader.isContextViewDeliveryForAnnotationPdf()
        )
    ) {
        const bodyClone = JSON.parse(JSON.stringify(body));

        if (printParams !== undefined) {
            bodyClone.values = Object.assign({}, bodyClone.values, printParams);
        }

        if (layoutParams !== undefined) {
            bodyClone.values = Object.assign({}, bodyClone.values, layoutParams);
        }

        return bodyClone;
    }

    return body;
}

const settingsActions = {
    types: {
        SETTINGS_LOAD_SUCCESS: 'SETTINGS_LOAD_SUCCESS',
        SETTINGS_LOAD_FAILED: 'SETTINGS_LOAD_FAILED',
        SETTINGS_UPDATED: 'SETTINGS_UPDATED',
    },

    settingsLoadSuccess(body) {
        return { type: this.types.SETTINGS_LOAD_SUCCESS, body: applyExtraParams(body) };
    },

    settingsLoadFailed(body) {
        return { type: this.types.SETTINGS_LOAD_FAILED, body };
    },

    updateSetting(body) {
        return { type: this.types.SETTINGS_UPDATED, body: applyExtraParams(body) };
    },
};

export default settingsActions;
